import axios from 'axios';

let prefix = "/creep-wave-group"

const CreepWaveGroupApi = {
	listCreepWaveGroup(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getCreepWaveGroup(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveCreepWaveGroup(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createCreepWaveGroup(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateCreepWaveGroup(payload) {
		return axios.post(prefix + "/update", payload)
	},
	parseCreepWaveCsv(payload) {
		return axios.post(prefix + "/parse-google-sheet-csv", payload)
	},
}

export default CreepWaveGroupApi;